<ng-container *ngIf="(!permission || hasPermission) && (!show || show(element))">
  <icon-component
    [iconName]="getIcon()"
    [noSdxIcon]="!isSdxIcon"
    [clickable]="true"
    (iconClicked)="click($event)"
    [cssClass]="cssClasses"
    [toolTipText]="getTooltip()"
    [hidden]="hidden"
    [disabled]="disabled$ | async"
    test-data="table-column-button"
    [attr.test-data-icon-name]="getIcon()"
    [attr.test-data-icon-visible]="!hidden"
  ></icon-component>
</ng-container>
